const messages = {
  name: 'Notification Log |||| Notification Logs',
  fields: {
    to: 'TO',
    from: 'FROM',
    provider: 'PROVIDER',
    messageId: 'MESSAGE ID',
    messageType: 'MESSAGE TYPE',
    sentAt: 'SENT AT',
    status: 'STATUS',
    webhookUrl: 'WEBHOOK URL',
    webhookStatus: 'WEBHOOK STATUS',
    origin: 'Origin',
    destination: 'Destination',
    originAccount: 'Origin account',
    originReference: 'Origin reference',
    channel: 'Channel',
    error: 'Error',
  },
  filters: {
    destination: 'Destination',
    origin: 'Origin',
    originAccount: 'Origin account',
    originReference: 'Origin reference',
    sender: 'From',
    messageId: 'Message ID',
    messageType: 'Message type',
    provider: 'Provider',
    status: 'Status',
    webhookStatus: 'Webhook status',
    channel: 'Channel',
    allChannels: 'All channels',
    sentFrom: 'Sent from',
    sentTo: 'Sent to',
  },
  actions: {
    exportCsv: 'Export CSV',
  },
  details: {
    viewData: 'View data',
    title: 'Log details',
  },
  keepUntil: {
    label: 'Keep Until (Days) :',
    update: 'Update',
    current: '(Current: %{count} days)',
  },
  notifications: {
    updated: 'Retention updated',
    updateFailed: 'Could not update retention',
  },
};

export default messages;
